import { render, staticRenderFns } from "./ToggleFilters.vue?vue&type=template&id=2e964ed6&"
import script from "./ToggleFilters.vue?vue&type=script&lang=js&"
export * from "./ToggleFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports